import {useEffect, useRef, useState} from "react";

const CustomSelect = ({ onChange, value }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const options = [
        { value: '1', label: '1 개월', discount: null },
        { value: '3', label: '3 개월', discount: '3% 할인' },
        { value: '6', label: '6 개월', discount: '5% 할인' },
        // { value: '12', label: '12 개월', discount: '10% 할인' },
        // { value: '무제한', label: '무제한 이용', discount: '15% 할인' }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (optionValue) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    const selectedOption = options.find(opt => opt.value === value);

    return (
        <div className="quantity-control">
            <div className="quantity-label">구매 개월수 선택</div>
            <div className="custom-select" ref={dropdownRef}>
                <button
                    className="select-button"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {selectedOption?.label}
                </button>
                {isOpen && (
                    <div className="options-container">
                        {options.map((option) => (
                            <div
                                key={option.value}
                                className={`option ${value === option.value ? 'selected' : ''}`}
                                onClick={() => handleSelect(option.value)}
                            >
                                <span>{option.label}</span>
                                {option.discount && (
                                    <span className="discount-badge-detail">
                                        {option.discount}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomSelect;